import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

export default function SepaMandateDialog({
  open,
  mode = "setup",
  contractLabel,
  form,
  onChange,
  submitting,
  error,
  onClose,
  onSubmit,
}) {
  const isSetup = mode === "setup";

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isSetup ? "Configurar Mandato SEPA" : "Revogar Mandato SEPA"}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Contrato: {contractLabel || "-"}
          </Typography>

          {isSetup ? (
            <>
              <TextField
                label="IBAN"
                value={form?.iban || ""}
                onChange={(event) => onChange?.("iban", event.target.value.toUpperCase())}
                fullWidth
                required
                autoFocus
              />
              <TextField
                label="Nome do titular"
                value={form?.account_holder_name || ""}
                onChange={(event) => onChange?.("account_holder_name", event.target.value)}
                fullWidth
                required
              />
              <TextField
                label="Email do titular"
                type="email"
                value={form?.email || ""}
                onChange={(event) => onChange?.("email", event.target.value)}
                fullWidth
              />
              <Typography variant="caption" color="text.secondary">
                Estes dados serão usados para criar e sincronizar o mandato SEPA no Stripe.
              </Typography>
            </>
          ) : (
            <TextField
              label="Motivo da revogação"
              value={form?.reason || ""}
              onChange={(event) => onChange?.("reason", event.target.value)}
              fullWidth
              multiline
              minRows={3}
              autoFocus
              helperText="Opcional, mas útil para auditoria."
            />
          )}

          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancelar</Button>
        <Button variant="contained" onClick={onSubmit} disabled={submitting}>
          {submitting
            ? (isSetup ? "A processar..." : "A revogar...")
            : (isSetup ? "Confirmar SEPA" : "Revogar mandato")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
